/**
 * LayoutHeaderArea Component
 * includes fixed header and children components
 * renders when page loads
 */
import { useState, createContext } from "react";
import Header from "./Header";

export const SidebarOpenContext = createContext(true);

export default function LayoutHeaderArea({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const gridStyles: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: isSidebarOpen ? "22rem 1fr" : "0 1fr",
    gridTemplateRows: "auto 1fr",
    height: "100%",
  };

  return (
    <div className="d-grid h-100" style={gridStyles}>
      <div style={{ gridColumn: "1 / span 2" }}>
        <Header isSidebarOpen={isSidebarOpen} onToggleSidebar={toggleSidebar} />
      </div>

      <SidebarOpenContext.Provider value={isSidebarOpen}>
        {children}
      </SidebarOpenContext.Provider>
    </div>
  );
}
